import { createTheme } from '@one-thd/sui-atomic-components';

const WinterHoliday2026PrimarySeven = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

WinterHoliday2026PrimarySeven.palette['--sui-palette-background-primary'] = '205 29 49';

export { WinterHoliday2026PrimarySeven };